import styled from 'styled-components';
import { IMFormErrorSection } from '@insurancemenu/imenu-components-lib';

export const IMFormErrorSectionStyled = styled(IMFormErrorSection)`
  text-align: left;
`;
